import React, {useState, useEffect} from "react";
import Style from './pesquisa-component.module.scss'
import {useAppSelector, useAppDispatch} from '../../../features/hooks';
import { getConcursos, concursoState} from '../../../features/slices/concurso-slice';


const Pesquisa:React.FC<any> = (props) =>{
    let c = useAppSelector(concursoState);


    const [busca, setBusca] = useState('');
    
    const concursosFiltrados = c.concursos?.filter((concurso:any) => concurso.titulo.toLowerCase().includes(busca.toLowerCase()));
    
    // (concursosFiltrados)

    return (
        <>
            <div className={Style.campo}>
                <input onChange={(ev) => setBusca(ev.target.value)} type="search" placeholder="Pesquisar concurso..." className={Style.input} value={busca} ></input>
                <img className={Style.img} src="https://cdn-icons-png.flaticon.com/512/711/711319.png"></img>
            </div>
        </>
    )
}

export default Pesquisa;